export default "__VITE_ASSET__e51bceaa__"